export default (data, category) => {
  let cate = [];
  const { REACT_APP_LOCATION } = process.env;
  switch (category) {
    case 'years':
      cate = data.map(cat => ({ label: cat.incident_year, value: cat.incident_year }));
      if (REACT_APP_LOCATION === 'corpus_christi') {
        cate.unshift({ label: 'All', value: 0 });
      }
      return cate;

    case 'severity':
      cate = data.map(cat => ({ label: cat.severity, value: cat.severity }));
      cate.unshift({ label: 'All', value: 0 });
      return cate;

    case 'categories_factors':
      cate = data.map(cat => ({ label: cat.category, value: cat.category }));
      cate.unshift({ label: 'All', value: 0 });
      return cate;

    case 'weather':
      cate = data.map(cat => ({ label: cat.weather_condition, value: cat.weather_condition }));
      cate.unshift({ label: 'All', value: 0 });
      return cate;

    case 'categories_vehicles':
      cate = data.map(cat => ({ label: cat.category_type, value: cat.category_type }));
      cate.unshift({ label: 'All', value: 0 });
      return cate;

    default:
      return cate;
  }
};
